module.exports = __webpack_public_path__ + "img/2.69129ad4.png";